export const getUserDisplayName = (user = {}) => {
  if (user.username) {
    return user.username;
  }
  return user.email;
};

export default getUserDisplayName;
